import { GenericCard } from '~src/app/spaces/CardView/GenericCard';
import { Messages } from '~src/codegen/Localize';
import { ContentTypeFilterClause, ExplorableItemDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { AccelerationTasks } from '~src/dataAcceleration/resources/AccelerationTasks';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { AccelerationTaskContentType } from '~src/ts/models/ContentTypes';

import { getGenericDefaultFilters } from './getDefaultFilters';

export const AccelerationTaskDefinition: ExplorableItemDefinition = {
  itemType: 'accelerationTask',
  pluralName: Messages.accelerationTasks,
  singularName: Messages.accelerationTask,
  emptyStateMessage: Messages.accelerationTasksEmptyMessage,
  contentFilterKeys: [],
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: ServerFilterClauses.ContentType(['accelerationTask']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return AccelerationTasks.all().withExtraParams(AccelerationTaskContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list']
};
